import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { GmapDetailPage } from './gmap-detail.page';
import { PagesModule } from '../pages.module';

const routes: Routes = [
  {
    path: '',
    component: GmapDetailPage
  }
];

@NgModule({
  imports: [
    PagesModule,
    RouterModule.forChild(routes)
  ],
  declarations: [GmapDetailPage]
})
export class GmapDetailPageModule { }
